<tlk-modal-header header>
	{{ isSearchingMatches ? tr('PatientSearch.ImportTitle') : tr('PatientSearch.Title') }}
	<button tlkButton variant="ghost" size="l" right-icon (click)="modalWindowRef.close()">✕</button>
</tlk-modal-header>
<tlk-modal-content content [style.flex]="1" [style.overflow-y]="'auto'" [style.display]="'flex'" [style.flex-direction]="'column'">
	<div class="content-wrapper">
		<div class="search-bar" *ngIf="!isSearchingMatches">
			<tlk-text-input
				class="search-input"
				[(ngModel)]="query"
				(ngModelChange)="onQueryChange()"
				[placeholder]="tr('PatientSearch.SearchPlaceholder')"
				name="searchQuery">
				<tlk-search-icon tlk-prefix size="20"></tlk-search-icon>
			</tlk-text-input>
			<tlk-select
				class="filter-dropdown"
				[(ngModel)]="systemFilter"
				(ngModelChange)="onFilterChange()"
				[options]="filterOptions"
				[getOptionId]="getFilterId"
				[getOptionName]="getFilterName"
				[placeholder]="tr('PatientSearch.AllPatients')">
			</tlk-select>
		</div>

		<div class="info-banner" *ngIf="!loading && !isSearchingMatches && isBrowsingRecent && displayedPatients.length > 0">
			<span class="banner-text">{{ tr('PatientSearch.BannerText') }}</span>
		</div>

		<div class="results-area">
			<div class="loading-state" *ngIf="loading">
				<rx-delayed-spinner [loading]="loading"></rx-delayed-spinner>
			</div>

			<div class="empty-state" *ngIf="!loading && displayedPatients.length === 0 && isBrowsingRecent">
				<tlk-search-icon size="32"></tlk-search-icon>
				<span>{{ tr('PatientSearch.SearchPlaceholder') }}</span>
			</div>

			<div class="empty-state" *ngIf="!loading && displayedPatients.length === 0 && !isBrowsingRecent">
				<span>{{ tr('PatientSearch.NoResults') }}</span>
			</div>

			<table class="patient-table" *ngIf="!loading && displayedPatients.length > 0">
		<thead>
			<tr>
				<th></th>
				<th>{{ tr('PatientSearch.FullName') }}</th>
				<th>{{ tr('PatientSearch.Gender') }}</th>
				<th>{{ tr('PatientSearch.DateOfBirth') }}</th>
				<th class="nowrap">{{ tr('PatientSearch.ChartNumber') }}</th>
				<th class="nowrap">{{ tr('PatientSearch.Platform') }}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let patient of displayedPatients"
				[class.selected]="selectedPatient === patient"
				(click)="selectRow(patient)">
				<td class="avatar-cell">
					<rx-patient-avatar
						[firstName]="patient.firstName"
						[lastName]="patient.lastName"
						[thumbnailUrl]="(patient.invisalignId && thumbnailUrls.get(patient.invisalignId)) || null">
					</rx-patient-avatar>
				</td>
				<td class="name-cell">{{ patient.lastName }}, {{ patient.firstName }}</td>
				<td>{{ patient.gender === 'Male' ? 'M' : 'F' }}</td>
				<td>{{ patient.dateOfBirth | dobFormat }}</td>
				<td>{{ patient.chartNumber }}</td>
				<td class="platform-cell">
					<span *ngIf="patient.system === 'iTero'" tlk-badge backgroundColor="#F2EBFF" textColor="dark" size="m">iTero</span>
					<span *ngIf="patient.system === 'Invisalign'" tlk-badge backgroundColor="#DFF5FC" textColor="dark" size="m">Invisalign</span>
					<span *ngIf="patient.system === 'both'" tlk-badge backgroundColor="#E8F5E8" textColor="dark" size="m">{{ tr('PatientSearch.LinkedPatient') }}</span>
				</td>
			</tr>
		</tbody>
	</table>
		</div>
	</div>
</tlk-modal-content>
<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button tlkButton variant="secondary" size="m" (click)="modalWindowRef.close()">{{ tr('PatientSearch.Cancel') }}</button>
		<button tlkButton variant="primary" size="m" [disabled]="!selectedPatient" (click)="confirm()">{{ tr('PatientSearch.SelectPatient') }}</button>
	</ng-container>
</tlk-modal-footer>
